import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../shared/components/ui/modal/modal.component';
import { LabelComponent } from '../../shared/components/form/label/label.component';
import { InputFieldComponent } from '../../shared/components/form/input/input-field.component';
import { UbigeoPickerComponent } from '../../shared/components/form/ubigeo-picker/ubigeo-picker.component';
import { NotificationService } from '../../shared/components/ui/notification/notification.service';
import { OriginPointService } from '../../services/origin-point.service';
import { OriginPointResponse } from '../../dto/origin-point.response';
import { UbigeoResponse } from '../../dto/ubigeo.response';

@Component({
    selector: 'app-quick-origin-point-register',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ModalComponent,
        LabelComponent,
        InputFieldComponent,
        UbigeoPickerComponent,
    ],
    templateUrl: './quick-origin-point-register.component.html',
})
export class QuickOriginPointRegisterComponent implements OnChanges, OnDestroy {

    @Input() isOpen = false;
    @Input() ubigeos: UbigeoResponse[] = [];
    @Input() loadingUbigeos = false;
    @Output() onClose = new EventEmitter<void>();
    @Output() onCreated = new EventEmitter<OriginPointResponse>();

    private sub = new Subscription();

    submitted = false;
    isSubmitting = false;

    name = '';
    address = '';
    ubigeo = '';
    localCode = '';

    constructor(
        private originPointService: OriginPointService,
        private notify: NotificationService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isOpen'] && this.isOpen) {
            this.reset();
        }
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private isFormValid(): boolean {
        return !!this.name.trim() && !!this.address.trim() && !!this.ubigeo.trim();
    }

    onSubmit(): void {
        this.submitted = true;
        if (!this.isFormValid()) return;

        this.isSubmitting = true;
        const s = this.originPointService.create({
            name: this.name.trim(),
            address: this.address.trim(),
            ubigeo: this.ubigeo.trim(),
            localCode: this.localCode.trim() || undefined,
        }).subscribe({
            next: res => {
                this.isSubmitting = false;
                this.notify.success(res?.message ?? 'Punto de partida registrado correctamente');
                this.onCreated.emit(res.data!);
            },
            error: err => {
                this.isSubmitting = false;
                this.notify.error(err?.error?.message ?? 'No se pudo registrar el punto de partida.');
            },
        });
        this.sub.add(s);
    }

    close(): void {
        this.onClose.emit();
    }

    private reset(): void {
        this.submitted = false;
        this.isSubmitting = false;
        this.name = '';
        this.address = '';
        this.ubigeo = '';
        this.localCode = '';
    }
}
